import { render, staticRenderFns } from "./VulnerabilityList.vue?vue&type=template&id=22d17838&"
import script from "./VulnerabilityList.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports